import React from 'react';
import authService, { type Store as StoreType, type StoreUser } from '../../../services/authService';

const getStoreOwner = (users: StoreUser[]): StoreUser | null =>
    users.find((user) => {
        const role = (user.role || '').toLowerCase();
        return role === 'owner' || role === 'store_owner' || role.includes('owner');
    }) ?? null;

export const useStoreDetailsHeaderContext = (storeId?: string) => {
    const [store, setStore] = React.useState<StoreType | null>(null);
    const [storeOwner, setStoreOwner] = React.useState<StoreUser | null>(null);

    React.useEffect(() => {
        if (!storeId) {
            setStore(null);
            setStoreOwner(null);
            return;
        }

        let isCurrent = true;

        const loadHeaderContext = async () => {
            try {
                const [nextStore, users] = await Promise.all([
                    authService.getStoreDetails(storeId),
                    authService.getStoreUsers(storeId),
                ]);

                if (!isCurrent) {
                    return;
                }

                setStore(nextStore);
                setStoreOwner(getStoreOwner(users));
            } catch (error) {
                console.error('Failed to load store details header context', error);
                if (!isCurrent) {
                    return;
                }

                setStore(null);
                setStoreOwner(null);
            }
        };

        void loadHeaderContext();

        return () => {
            isCurrent = false;
        };
    }, [storeId]);

    return {
        store,
        storeOwner,
    };
};
